import { Container, Box } from "@material-ui/core";

import { AgreementSection } from "./AgreementSection";
import { GardenerDocument } from "../../gardener/gardener.model";
import { ContentSection } from "../../application/ContentSection";
import { PurpleButton } from "../../components/button/PurpleButton";
import { FloatingButton } from "../../components/floating-button/FloatingButton";
import { useTranslation } from "../../internationalisation/translation.hook";
import { formatDate } from "../../utility";

interface AgreementPageProps {
    gardener: GardenerDocument;
}

export const AgreementPage = (props: AgreementPageProps) => {
    const { t } = useTranslation();

    const { gardener } = props;

    return (
        <ContentSection>

            <Container maxWidth="md" disableGutters>

                <Box marginBottom={4}>
                    <AgreementSection />
                </Box>

                <FloatingButton>
                    {gardener.status === "terminated" ? (
                        <PurpleButton disabled>
                            {gardener.terminationDate ? t("AgreementPage: terminated-cooperation-agreement-button-with-date").replaceAll("$DATE", formatDate(gardener.terminationDate)) : t("AgreementPage: terminated-cooperation-agreement-button-without-date")}
                        </PurpleButton>
                    ) : (
                        <PurpleButton disabled>{t("AgreementPage: already-accepted-cooperation-agreement-button")}</PurpleButton>
                    )}
                </FloatingButton>

            </Container>

        </ContentSection>
    );
};
